import React, { Component } from 'react';
import NavigationBar from "../components/navigationBar";

import UserService from '../service/userService';
import AuthTokenService from '../service/authTokenService';
import RoleService from '../service/roleService';

import "../design/loginform.css";

export default class Users extends Component {
    constructor(props) {
        super(props);

        this.userService = new UserService();
        this.roleService = new RoleService();
        this.authTokenService= new AuthTokenService();

        this.state = {
            uuid: null,
            username: null,
            email: null,
            userroles: [],
            enabled: false,
            authorizedUser: null,
            newpassword: "",
            allUserRoles : [],
            rolesToGive: [],
            rolesToRemove: []
        }

        this.enableUser = this.enableUser.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleRoleToGive = this.handleRoleToGive.bind(this);
        this.handleRoleToRemove = this.handleRoleToRemove.bind(this);
        
    }

    handleChange({ target }) {
        this.setState({
            [target.name]: target.value
        });
    }


    async changePassword(event) {
        event.preventDefault();

        if(!this.state.NewPassword){
            return;
        }

        let results = await this.authTokenService.adminChangeUserPassword(this.state.uuid, this.state.NewPassword);
        if (results.status === 401) {
            this.props.history.push("/Login");
        }
    }


    async getAuthorizedUser() {
        let result = await this.userService.getMe();
        console.log(result);
        if (result.status === 401) {
            this.props.history.push("/Login");
        }
        else {
            this.setState({
                authorizedUser: result
            })
        }
    }

    async getUserDetailed() {
        let result = await this.userService.getUserDetails(this.props.match.params.useruuid);
        console.log(result);
        if (result.status === 401) {
            this.props.history.push("/Login");
        }
        else {
            this.setState({
                uuid: result.uuid,
                username: result.userName,
                userroles: result.userRoles,
                email: result.email,
                enabled: result.enabled
            })
        }
    }

    async getAllUserRoles() {
        let result = await this.roleService.getRoles();
        console.log(result);
        if (result.status === 401) {
            this.props.history.push("/Login");
        }
        else {
            this.setState({
                allUserRoles: result
            })
        }
    }

    handleRoleToGive(event, roleId) {
        let existsIndex = this.state.rolesToGive.indexOf(roleId);
        if (event.target.checked) {
            if (existsIndex === -1) {
                let array = this.state.rolesToGive;
                array.push(roleId);
                this.setState(() => ({ rolesToGive: array }))
            };
        }
        else {
            if (existsIndex !== -1) {
                let array = this.state.rolesToGive;
                array.splice(existsIndex, 1);
                this.setState(() => ({ rolesToGive: array }))
            }
        }
    }

    handleRoleToRemove(event, roleId) {
        let existsIndex = this.state.rolesToRemove.indexOf(roleId);
        if (event.target.checked) {
            if (existsIndex === -1) {
                let array = this.state.rolesToRemove;
                array.push(roleId);
                this.setState(() => ({ rolesToRemove: array }))
            };
        }
        else {
            if (existsIndex !== -1) {
                let array = this.state.rolesToRemove;
                array.splice(existsIndex, 1);
                this.setState(() => ({ rolesToRemove: array }))
            }
        }
    }

    async giveRolesToUser(event){
        event.preventDefault();

        await this.roleService.addRolesToUser(this.state.uuid,this.state.rolesToGive);

        this.componentDidMount();

    }

    async removeRolesFromUser(event){
        event.preventDefault();

        await this.roleService.removeRolesFromUser(this.state.uuid,this.state.rolesToRemove);

        this.componentDidMount();

    }

    async enableUser(event) {
        await this.userService.changeUserState(this.state.uuid, !this.state.enabled);
        this.getUserDetailed();
    }

    componentDidMount() {
        this.getAuthorizedUser();
        this.getUserDetailed();
        this.getAllUserRoles();
    }


    render() {
        const uuid = this.state.uuid;
        if (!uuid) return null;
        const authorizedUser = this.state.authorizedUser;
        if(!authorizedUser) return null;

        return (
            <div className="body">
                <NavigationBar {...this.props} />
                <main>
                    <div className="task-detail-primary-info">
                        <div className="task-detail-container-vertical">
                            <center><h1>Profile</h1></center>
                            <div><b>User uuid: </b> <br /> {this.state.uuid}</div>
                            <div><b>Enabled: </b> <br /> {this.state.enabled ? "true" : "false"}<br />

                            {
this.state.authorizedUser.userRoles.includes("ADMIN") && this.state.authorizedUser.uuid !== this.state.uuid ?
                                <button onClick={(event) => { this.enableUser(event) }}>{this.state.enabled ? 'Disable' : 'Enable'}</button>: ""
                            }
                            </div>
                            <div><b>Username: </b><br /> {this.state.username}</div>
                            <div><b>Email: </b> <br />{this.state.email}</div>
                            <div><b>Roles:</b> <br />
                                {this.state.userroles.map((role) => (
                                    <div>{role}</div>
                                ))}</div>
                            {  this.state.authorizedUser.userRoles.includes("ADMIN") && this.state.authorizedUser.uuid !== this.state.uuid ?
                                <div>
                                <h2>Change Password For user</h2>
                                    <form action="#" onSubmit={(event) => { this.changePassword(event) }}>
                                        <label className="labelLoginForm" htmlFor="NewPassword"><b>New Password:</b></label><br />
                                        <input className="loginInputLabel" type="password" placeholder="New Password" name="NewPassword" value={this.state.NewPassword} onChange={this.handleChange} required /><br />

                                        <button className="buttonLoginSubmit" type="submit">Change Password</button>
                                    </form>

                            </div> : ""
                            }
                            {  this.state.authorizedUser.userRoles.includes("ADMIN") && this.state.authorizedUser.uuid !== this.state.uuid ?
                                <div>
                                <h2>Add Roles to user</h2>
                                    <form action="#" onSubmit={(event) => { this.giveRolesToUser(event) }}>
                                        
                                        
                                        {this.state.allUserRoles.map((role) => (
                                                this.state.userroles.includes(role) ? "" :
                                                <div>
                                                    <input type="checkbox" onClick={(event) => { this.handleRoleToGive(event, role) }} />
                                                    <label for={role}>{role}</label>
                                                </div>
                                                )
                                            )   
                                        }
                                        
                                        <button className="buttonLoginSubmit" type="submit">Give Roles To User</button>
                                    </form>

                            </div> : ""
                            }

                            {  this.state.authorizedUser.userRoles.includes("ADMIN") && this.state.authorizedUser.uuid !== this.state.uuid ?
                                <div>
                                <h2>Remove Roles from user</h2>
                                    <form action="#" onSubmit={(event) => { this.removeRolesFromUser(event) }}>    
                                        {this.state.userroles.map((role) => (
                                                <div>
                                                    <input type="checkbox" onClick={(event) => { this.handleRoleToRemove(event, role) }} />
                                                    <label for={role}>{role}</label>
                                                </div>
                                                )
                                            )   
                                        }
                                        
                                        <button className="buttonLoginSubmit" type="submit">Remove Roles From User</button>
                                    </form>

                            </div> : ""
                            }
                        </div>
                    </div>
                </main>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/sites/userdetail.js